import { render, staticRenderFns } from "./ReservationCancelPopup.vue?vue&type=template&id=2126748c&"
import script from "./ReservationCancelPopup.vue?vue&type=script&lang=js&"
export * from "./ReservationCancelPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports